export default "__VITE_ASSET__BGInS66g__"